import { render, staticRenderFns } from "./EinstellungenZahlungen.vue?vue&type=template&id=216f763a&"
import script from "./EinstellungenZahlungen.vue?vue&type=script&lang=js&"
export * from "./EinstellungenZahlungen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports